export const leavesArray = [
  'Annual Leave',
  'Casual Leave',
  'Sick Leave',
  'Short Leave',
  'Lieu Leave',
  'Maternity Leave',
  'Paternity Leave',
  'No Pay Leave',
  'Leave for Voting',
  'Study Leave',
  'Special Leave'
];

export const employeeTypes = [
  'Permanent', 'Probation', 'Intern'
];

export const employeeStatus = [
  'Active', 'Inactive'
];